import {Inject, NgModule, Optional, PLATFORM_ID} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { MobileMenuComponent } from './components/navbar/mobile-menu/mobile-menu.component';
import { ProfileService } from "./Services/profile.service";
import { CategoriesNavComponent } from './components/navbar/categories-nav/categories-nav.component';
// import { AboutusComponent } from './components/page/aboutus/aboutus.component';
import { SplashService } from './Services/splash.service';
import { SplashComponent } from './components/splash/splash.component';
import { CategoriesModalModule } from './components/categories-modal';
import { DirectivesModule } from "./directives/directives.module";
import { GoogleReserveComponent } from './components/page/google-reserve/google-reserve.component';
import { InvestorsComponent } from './components/page/investors/investors.component';
import { FestiveBannersComponent } from './components/festive-banners/festive-banners.component';
import {isPlatformBrowser} from "@angular/common";
import {CITY, CITY_FROM_SERVER} from "./tokens";

@NgModule({ declarations: [
        AppComponent,
        NavbarComponent,
        FooterComponent,
        SplashComponent,
        MobileMenuComponent,
        CategoriesNavComponent,
        GoogleReserveComponent,
        InvestorsComponent,
        FestiveBannersComponent
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule.withServerTransition({ appId: 'serverApp' }),
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        CategoriesModalModule,
        DirectivesModule],
  providers: [
    ProfileService,
    SplashService,
    provideHttpClient(withFetch()),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: CITY,
      useFactory: (cityFromServer: string | null, platformId: Object) => {
        if (cityFromServer) return cityFromServer;
        if (isPlatformBrowser(platformId)) {
          const host = window.location.host || 'booky.mk';
          const domainParts = host.split('.');

          if (domainParts.length < 2) return 'sofia';

          const subdomain = domainParts[0].toLowerCase();
          const tld = domainParts[domainParts.length - 1].toLowerCase();

          if (subdomain === 'booky' && tld === 'mk') return 'skopje';
          if (subdomain === 'booknow' && tld === 'rs') return 'beograd';

          return domainParts.length > 2 ? subdomain : 'sofia';
        }
        return 'sofia'; // fallback on server if no cityFromServer provided
      },
      deps: [[new Optional(), new Inject(CITY_FROM_SERVER)], PLATFORM_ID]
    }
    ] })
export class AppModule { }
